export default function removeKey(object, key) {
  const newObj = Object.assign({}, object);
  delete newObj[key];
  return newObj;
}

export function removeKeys(object, keys) {
  const newObj = Object.assign({}, object);
  keys.forEach(k => delete newObj[k]);
  return newObj;
}



// WEBPACK FOOTER //
// ./app/lib/removeKey.js